import React from "react";
import { Button, Modal } from "react-bootstrap";
import classes from "./ModalSkeleton.module.css";

export default function ModalSkeleton({
  show,
  setShow,
  className,
  children,
  closeBtn = false,
  modalWidth,
  modalPadding,
}) {
  return (
    <>
      <style>
        {`

.modal-backdrop {

  background: transparent linear-gradient(180deg, #4A4F74 0%, #5A5F87 100%) 0% 0% no-repeat padding-box !important;
  opacity: 0.96 !important;
}



        .modal-content {
          border-radius: 50px;
        }
      .modal-header {
        border: 0;
    }
    .modal-body {
      padding: ${modalPadding ? modalPadding : "140px"};
    }
        @media (min-width: 576px){
.modal-dialog {
    max-width:${modalWidth ? modalWidth : "60%"};
    margin: 1.75rem auto;
}}




      
      `}
      </style>
      <Modal
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={setShow}
        className={className && className}
      >
        {closeBtn && <Modal.Header closeButton></Modal.Header>}
        <Modal.Body>{children}</Modal.Body>
      </Modal>
    </>
  );
}
